module.exports = __webpack_public_path__ + "fonts/Graphik-Light.532fcbe.otf";